import { Attempt } from '@/common/types/session';
import { formatTimeTaken } from '@/common/utils/datetime';
import { getWordById, getWordGraphemes } from '@/common/utils/scopeAndSequence';
import { TableCell, TableHead, TableRow } from '@shadcn/components/table';
import GenericAttemptTable, {
  getControlIcon,
  getHasControl,
  renderStudentAnswer,
} from './GenericAttemptTable';

interface AssessmentAttemptTableProps {
  attempts: Attempt[];
}
export default function AssessmentAttemptTable({
  attempts,
}: AssessmentAttemptTableProps) {
  const hasControl = getHasControl(attempts);

  const getCorrectSegments = (itemId: string) => {
    const word = getWordById(itemId);
    if (!word) return;
    return getWordGraphemes(word).map((g) => g.spelling);
  };

  return (
    <GenericAttemptTable
      renderHeader={() => (
        <TableRow className="hover:bg-white">
          <TableHead>Question</TableHead>
          <TableHead>Served Word</TableHead>
          <TableHead>Student Attempt</TableHead>
          <TableHead>Time Taken</TableHead>
          {hasControl && <TableHead>Control</TableHead>}
        </TableRow>
      )}
      renderData={() =>
        attempts.map((attempt, index) => {
          return (
            <TableRow key={index} className="hover:bg-white">
              <TableCell>{index + 1}</TableCell>
              <TableCell>{attempt.correctAnswer}</TableCell>
              <TableCell className="flex items-center">
                {renderStudentAnswer({ attempt, getCorrectSegments })}
              </TableCell>
              <TableCell>
                {formatTimeTaken(attempt.startedAt, attempt.endedAt)}
              </TableCell>
              {hasControl && (
                <TableCell className="pl-6">
                  {getControlIcon(attempt.control!)}
                </TableCell>
              )}
            </TableRow>
          );
        })
      }
      isEmpty={attempts.length === 0}
    />
  );
}
